<div
    class="miles-editable miles-card padded"
    *ngIf="!isEditing && office.Id > 0"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    (click)="edit()"
    [style.cursor]="canEdit ? 'pointer' : 'default'"
>
    <h4>
        Office Info
        <span class="pull-right" *ngIf="canEdit" [hidden]="!isHovered">
            <i class="fa fa-lg fa-edit"></i>
        </span>
    </h4>
    <mt-dynamic-view [config]="viewOnly"></mt-dynamic-view>
    <div
        class="form-group"
        style="
            margin-top: 14px;
            padding: 12px;
            border: 1px solid #d7dde6;
            border-radius: 8px;
            background: linear-gradient(180deg, #fbfdff 0%, #f7f9fc 100%);
        "
    >
        <div style="font-size: 11px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: #5f6b7a; margin-bottom: 6px">
            Weekly Check-in Schedule
        </div>
        <div style="max-width: 100%; overflow-x: auto">
            <table style="width: 100%; border-collapse: separate; border-spacing: 0 6px">
                <thead>
                    <tr>
                        <th style="width: 1%"></th>
                        <th style="text-align: left; font-size: 12px; color: #677488; padding: 2px 8px">Weekday</th>
                        <th style="text-align: left; font-size: 12px; color: #677488; padding: 2px 8px">Check-in Start</th>
                        <th style="text-align: left; font-size: 12px; color: #677488; padding: 2px 8px">Check-out End</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let schedule of weekdaySchedules"
                        [style.background]="schedule.enabled ? '#ffffff' : '#f5f6f8'"
                        [style.opacity]="schedule.enabled ? '1' : '0.65'"
                    >
                        <td
                            style="
                                padding: 8px 8px;
                                border-top: 1px solid #e5e9ef;
                                border-bottom: 1px solid #e5e9ef;
                                border-left: 1px solid #e5e9ef;
                                border-radius: 6px 0 0 6px;
                            "
                        >
                            <input type="checkbox" [checked]="schedule.enabled" disabled style="margin: 0" />
                        </td>
                        <td
                            style="
                                padding: 8px;
                                border-top: 1px solid #e5e9ef;
                                border-bottom: 1px solid #e5e9ef;
                                font-weight: 600;
                                color: #334055;
                                white-space: nowrap;
                            "
                        >
                            {{ schedule.day }}
                        </td>
                        <td
                            style="
                                padding: 8px;
                                border-top: 1px solid #e5e9ef;
                                border-bottom: 1px solid #e5e9ef;
                                font-variant-numeric: tabular-nums;
                                color: #2f3a4b;
                                white-space: nowrap;
                            "
                        >
                            {{ schedule.startTime }}
                        </td>
                        <td
                            style="
                                padding: 8px;
                                border-top: 1px solid #e5e9ef;
                                border-bottom: 1px solid #e5e9ef;
                                border-right: 1px solid #e5e9ef;
                                border-radius: 0 6px 6px 0;
                                font-variant-numeric: tabular-nums;
                                color: #2f3a4b;
                                white-space: nowrap;
                            "
                        >
                            {{ schedule.endTime }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div *ngIf="isEditing" class="miles-form padded">
    <h4>Office Info</h4>
    <mt-dynamic-form [config]="formObject" (submitted)="formSubmitted($event)">
        <div class="form-group">
            <div
                style="
                    display: grid;
                    grid-template-columns: minmax(130px, auto) 1fr 1fr;
                    gap: 6px 12px;
                    align-items: center;
                    max-width: 100%;
                    overflow: hidden;
                "
            >
                <span></span>
                <small class="text-muted">Check-in Start</small>
                <small class="text-muted">Check-in End</small>

                <label><input type="checkbox" [(ngModel)]="office.DefaultWeekdayMon" name="DefaultWeekdayMon" />&nbsp;Every Monday</label>
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInStartTimeMon"
                    name="CheckInStartTimeMon"
                />
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInEndTimeMon"
                    name="CheckInEndTimeMon"
                />

                <label><input type="checkbox" [(ngModel)]="office.DefaultWeekdayTue" name="DefaultWeekdayTue" />&nbsp;Every Tuesday</label>
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInStartTimeTue"
                    name="CheckInStartTimeTue"
                />
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInEndTimeTue"
                    name="CheckInEndTimeTue"
                />

                <label><input type="checkbox" [(ngModel)]="office.DefaultWeekdayWed" name="DefaultWeekdayWed" />&nbsp;Every Wednesday</label>
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInStartTimeWed"
                    name="CheckInStartTimeWed"
                />
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInEndTimeWed"
                    name="CheckInEndTimeWed"
                />

                <label><input type="checkbox" [(ngModel)]="office.DefaultWeekdayThu" name="DefaultWeekdayThu" />&nbsp;Every Thursday</label>
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInStartTimeThu"
                    name="CheckInStartTimeThu"
                />
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInEndTimeThu"
                    name="CheckInEndTimeThu"
                />

                <label><input type="checkbox" [(ngModel)]="office.DefaultWeekdayFri" name="DefaultWeekdayFri" />&nbsp;Every Friday</label>
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInStartTimeFri"
                    name="CheckInStartTimeFri"
                />
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInEndTimeFri"
                    name="CheckInEndTimeFri"
                />

                <label><input type="checkbox" [(ngModel)]="office.DefaultWeekdaySat" name="DefaultWeekdaySat" />&nbsp;Every Saturday</label>
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInStartTimeSat"
                    name="CheckInStartTimeSat"
                />
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInEndTimeSat"
                    name="CheckInEndTimeSat"
                />

                <label><input type="checkbox" [(ngModel)]="office.DefaultWeekdaySun" name="DefaultWeekdaySun" />&nbsp;Every Sunday</label>
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInStartTimeSun"
                    name="CheckInStartTimeSun"
                />
                <input
                    type="time"
                    class="form-control input-sm"
                    style="min-width: 0"
                    [(ngModel)]="office.CheckInEndTimeSun"
                    name="CheckInEndTimeSun"
                />
            </div>
        </div>
        <button type="submit" mtDisableClickDuringHttpCalls Class="btn btn-flat btn-success">Save</button>
        <button type="button" Class="btn btn-flat btn-default" (click)="cancelClick()">Cancel</button>
    </mt-dynamic-form>
</div>
